module.exports = __webpack_public_path__ + "static/img/noex.9603118.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portal/noex.png
// module id = 2uaW
// module chunks = 32